var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconIvstTdy02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1017_6793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1016 21.375H23.1016",
    stroke: "#00BAA2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1016 16.875H23.1016",
    stroke: "#00BAA2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1016 5.625H28.7266C29.0249 5.625 29.3111 5.74353 29.5221 5.95451C29.733 6.16548 29.8516 6.45163 29.8516 6.75V30.375C29.8516 30.6734 29.733 30.9595 29.5221 31.1705C29.3111 31.3815 29.0249 31.5 28.7266 31.5H8.47656C8.17819 31.5 7.89205 31.3815 7.68107 31.1705C7.47009 30.9595 7.35156 30.6734 7.35156 30.375V6.75C7.35156 6.45163 7.47009 6.16548 7.68107 5.95451C7.89205 5.74353 8.17819 5.625 8.47656 5.625H14.1016",
    stroke: "#00BAA2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9766 10.125V9C12.9766 7.50816 13.5692 6.07742 14.6241 5.02252C15.679 3.96763 17.1097 3.375 18.6016 3.375C20.0934 3.375 21.5241 3.96763 22.579 5.02252C23.6339 6.07742 24.2266 7.50816 24.2266 9V10.125H12.9766Z",
    stroke: "#00BAA2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1017_6793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(0.601562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIvstTdy02);
export default __webpack_public_path__ + "static/media/icon-ivst-tdy-02.3dc1a8c190b9abd6a7abda10dc2a38fb.svg";
export { ForwardRef as ReactComponent };